<template>
  <div :class="{'app-elements-area-wireframe': true, 'app-elements-area-wireframe--show': show, 'handle': numberOfAreas > 1}">
    <img
      class="app-elements-area-wireframe__img"
      :src="wireframeUrl"
    >
  </div>
</template>

<script>
/**
 * Die Darstellungskomponente für ein Area Wireframe
 * @displayName AppElementsAreaWireframe
 */
export default {
  name: 'AppElementsAreaWireframe',
  props: {
    /**
     * Der Identifier
     */
    identifier: {
      type: String,
      required: true
    },
    /**
     * Das Element
     */
    element: {
      type: Object,
      required: true
    },
    /**
     * Soll der Wireframe sichtbar sein?
     */
    show: {
      type: Boolean
    },
    numberOfAreas: {
      type: Number,
      required: true
    }
  },
  emits: ['height'],
  data() {
    return {
      height: 0,
    }
  },
  computed: {
    wireframeUrl() {
      let array = this.identifier.split('.');
      let areaIdentifier = array[array.length - 1];
      let string = this.$store.state.rootUrl + 'build/pix/components/areas/' + areaIdentifier.replaceAll('-','_');

      Object.keys(this.element.selection).forEach((key) => {
        let option = this.element.selection[key];

        string += '--' + option;
      })

      string += '.png';

      return string
    },
    view() {
      return this.$store.state.currentView
    },
    viewClass() {
      return 'app-elements-area-wireframe__img--' + this.view
    }
  },
  methods: {
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  }
}
</script>

<style lang="less">
img {
  max-width: 100%;
}

.app-elements-area-wireframe {
  &__panel {
    border: none;
    box-shadow: none;
    background-color: transparent;
    position: relative;
    margin-bottom: 0;
    //padding-top: 46px;
    //transition: padding-top 0.5s ease 0.5s;

    .panel-heading {
      padding: 5px 10px;
      background-color: #f5f5f5;
      color: #333333;
      font-size: 14px;
      border: 1px solid #dedede;
      border-radius: 3px;
      transition: top 0.2s ease 0s, left 0.2s ease 0s, right 0.2s ease 0s, position 0s ease 0.2s;
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      margin-bottom: -10px;
    }

    .panel-body {
      padding: 0;
      line-height: 0;
    }

    .app-elements-area-wireframe__img {
      max-height: 0;
      width: 100%;
      transition: max-height 0.5s ease 0s;
    }
    .item--show-on-hover {
      transition: all 0.5s;
      opacity: 0;
    }
  }

  &__panel--wireframe-visible {
    padding-top: 0;

    .panel-title--show-on-hover,
    .item--show-on-hover {
      line-height: 1.6;
      transition: all 0.5s;
      opacity: 0;
    }

    .item--show-on-hover {
      @media (max-width: 991px) {
        opacity: 1;
      }
    }

    .panel-heading {
      background: unset;
      border: unset;
    }

    .app-elements-area-wireframe__img {
      max-height: 2000px;
    }
  }

  &__panel--printing {
    .panel-heading {
      background-color: transparent !important;
      position: static !important;
      display: none !important;
    }

    .panel-title {
      font-size: 1rem !important;
      margin-bottom: 15px;
    }
  }
}
</style>
